export function formatRelativeTimeWithIntl(
  input: Date | string,
  locale: string
): string {
  const target =
    typeof input === 'string' ? new Date(input) : new Date(input.getTime())
  if (Number.isNaN(target.getTime())) {
    return ''
  }
  const rtf = new Intl.RelativeTimeFormat(locale, { numeric: 'auto' })
  const divisions: { amount: number; unit: Intl.RelativeTimeFormatUnit }[] = [
    { amount: 60, unit: 'second' },
    { amount: 60, unit: 'minute' },
    { amount: 24, unit: 'hour' },
    { amount: 7, unit: 'day' },
    { amount: 4.34524, unit: 'week' },
    { amount: 12, unit: 'month' },
    { amount: Number.POSITIVE_INFINITY, unit: 'year' },
  ]
  let durationSeconds = (target.getTime() - Date.now()) / 1000
  for (const division of divisions) {
    if (Math.abs(durationSeconds) < division.amount) {
      return rtf.format(Math.round(durationSeconds), division.unit)
    }
    durationSeconds /= division.amount
  }
  return rtf.format(0, 'second')
}
